import { useState, useContext } from "react";
import BlockchainContext from "../store/BlockchainContext";
import { walletAddressSlicer, numberWithCommas } from "../utils/util";
import { ABI, BUSDTOKENABI } from "../utils/abi";
import whiteSpinner from "../assets/img/spin.svg";
import Countdown from "react-countdown";
import { toast } from "react-toastify";

const StakeSection = () => {
  const [amount, setAmount] = useState();
  const {
    account,
    walletBalance,
    web3Instance,
    myMiner,
    myreward,
    Contract,
    userCheckPoint,
    hatchpending,
    Sellpending,
    array,
    pending,
    approveBusd,
    busdStakeText,
    buyEggs,
    hatchBird,
    sellBird,
  } = useContext(BlockchainContext);

  /*const balance =  (contract, web3) => {
    const contract = new web3Instance.eth.Contract(
      ABI,
      process.env.REACT_APP_CONTRACT
    );
  }

  document.addEventListener("DOMContentLoaded", e => balance(Contract,web3Instance));*/

  console.log(array);

  const [contract, web3, acc] = array;

  let final = 0;

  const _balance = async () => {
    if (!acc || acc === undefined) return;
    await contract.methods
      .users(acc)
      .call(
        (error, result) => (final = web3.utils.fromWei(result[0].toString()))
      );
    localStorage.setItem("balance", final);
  };

  const _getBotLevel = async () => {
    if (!acc || acc === undefined) return;
    await contract.methods
      .getMyBotLevel(acc)
      .call(
        (error, result) => (final = result)
      );
    localStorage.setItem("botLevel", final);
  };

  document.addEventListener("DOMContentLoaded", _getBotLevel());  
  document.addEventListener("DOMContentLoaded", _balance());

  const rendererCountdown = ({ days, hours, minutes, seconds, completed }) => {
    // completed ? <Completionist /> : <span>{days}d {hours}h {minutes}m {seconds}</span>;
    if (completed) {
      return "";
    } else {
      return (
        <p className="count-text">
          {String(hours).padStart(2, "0")} : {String(minutes).padStart(2, "0")}{" "}
          : {String(seconds).padStart(2, "0")}
        </p>
      );
    }
  };

  const handleBuyBird = () => {
    if (new Date().getTime() > 1654512659) {
      if (busdStakeText === "Enable") {
        approveBusd(account);
      } else {
        if (Number(amount) > 0) {
          buyEggs(amount);
        } else {
          toast.error("Enter valid amount", {
            position: "bottom-right",
          });
        }
      }
    } else {
      toast.warn("Launch date is Saturday 14th May 2022 at 7pm UTC", {
        position: "bottom-right",
      });
    }
  };

  return (
    <main
      id="dashboard"
      className="pt-32 mx-auto max-w-7xl px-4 sm:pt-40 sm:px-6 lg:pt-48 pb-8 stake-padding"
      style={{ opacity: "1" }}
    >
      <div className="grid grid-cols-2 gap-2 md:grid-cols-1 xl:gap-5 sm:gap-3 mb-8 max-w-7xl mx-auto">
        <div className="col-start-1 col-span-2">
          <div className=" w-full h-full transition-all ease-in-out duration-200 shadow-xl relative overflow-hidden br-5 stake">
            <div className="box-padding">
              <div className="flex-card first" index="0">
                <p className="titulos">CONTRACT</p>
                <h5 className="titulos">
                  <a
                    className=""
                    href={process.env.REACT_APP_BNB_FACTOR_CONRACT}
                    target="_blank"
                  >
                    {process.env.REACT_APP_CONTRACT}
                  </a>
                </h5>
              </div>
              <div className="flex-card" index="1">
                <p className="title-saldos">WALLET</p>
                <h5 className="title-saldos">
                  {"$" + numberWithCommas(walletBalance, 2) + " USDT"}
                </h5>
              </div>
              <div className="flex-card" index="2">
                <p className="title-saldos">TOTAL INVESTED</p>
                <h5 className="title-saldos">
                  {"$" + localStorage.getItem("balance") + " USDT"}{" "}
                </h5>
              </div>
              <div className="flex-card" index="3">
                <p className="titulos">REWARDS</p>
                <h5 className="titulos">
                  ${numberWithCommas(myreward, 2)} USDT
                </h5>
              </div>

              <div className="stake-bottom">
                <div className="stake-bottom-item">
                  <div className="">
                    <div className="relative">
                      <input
                        className="input-stake"
                        type="text"
                        value={amount}
                        step={0.00001}
                        onChange={(event) => {
                          if (
                            event.target.value >= 0 ||
                            event.target.value === ""
                          ) {
                            setAmount(event.target.value); // Ningun error
                          }
                        }}
                      />
                      <b className="input-current">ENTER AMOUNT IN USDT</b>
                    </div>
                  </div>
                  <div className="">
                    <button
                      className="button-secondary invest"
                      onClick={() => handleBuyBird()} // Ningun error
                    >
                      {pending ? <>{"PENDING..."}</> : <>{busdStakeText}</>}
                    </button>
                  </div>
                </div>
                <div className="stake-bottom-item">
                  <div className="flex-card reward"></div>
                  <div className="box-border flex flex-row stake-btns">
                    <div className="box-button">
                      <button
                        className="button-100 reinvest"
                        onClick={() => hatchBird()}
                      >
                        {hatchpending ? (
                          <>{"PENDING..."}</>
                        ) : (
                          <>REINVEST 100%</>
                        )}
                      </button>
                    </div>
                    <div className="box-button">
                      <button
                        className={`button-100 withdraw ${
                          Number(userCheckPoint) > +new Date() ? "disable" : ""
                        }`}
                        disabled={userCheckPoint > +new Date() ? true : ""}
                        onClick={() => sellBird()}
                      >
                        {userCheckPoint > +new Date() ? (
                          <Countdown
                            date={userCheckPoint}
                            renderer={rendererCountdown}
                          />
                        ) : Sellpending ? (
                          <>{"PENDING..."}</>
                        ) : (
                          <>WITHDRAW</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StakeSection;
